import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { DiscountCreatePage } from '@/features/discounts';

export const Route = createFileRoute('/_authed/_active/s/$storeId/discounts/new')({
  staticData: { crumb: 'discounts:new', tours: ['discounts.editor'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'discounts.write');
  },
  component: DiscountCreatePage,
});
